import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken, isAuthed } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const nav = useNavigate();

  React.useEffect(() => { if (isAuthed()) nav("/admin"); }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      toast.success("Connecté");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-cef-paper pattern-grid">
      <form onSubmit={submit} className="neo-card p-8 w-full max-w-md bg-white" data-testid="admin-login-form">
        <Link to="/" className="text-xs font-bold uppercase tracking-widest text-neutral-500 hover:text-black">← Retour au site</Link>
        <Lock className="w-8 h-8 mt-4" strokeWidth={2.5} />
        <h1 className="mt-2 font-display font-black text-3xl tracking-tighter uppercase">Espace admin</h1>
        <p className="mt-1 text-sm text-neutral-600">Connexion réservée à l'équipe CEF.</p>

        <input className="neo-input mt-6" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
        <input className="neo-input mt-3" type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
        <button type="submit" disabled={loading} className="neo-btn bg-cef-blue text-white mt-5 w-full justify-center disabled:opacity-50" data-testid="admin-login-btn">{loading ? "…" : "Se connecter"}</button>
      </form>
    </div>
  );
}
